import YesBackground from './YesBackground';

export default YesBackground;
